export class ImportStaff {
    tenFile: string;
    schoolId: number;
    TypeOfPersonnelId : number;
    BoardId : number;
    PositionId : number;
    ReligionId : number;
    NationalityId : number;
    FolkId : number;
    ContractTypeId : number;
    QualificationId : number;  
    ketQuaImport: string;
    typeOfPersonnel : number;
    constructor() {
        this.tenFile = '';
        this.ketQuaImport = '';
    }
}